<template>
  <div class="row" id="reports">
    <div class="col-12">
      <v-col
        v-if="downloading"
        class="subtitle-1 text-center"
        cols="12"
      > Cargando por favor espere...
      </v-col>
      <v-progress-linear
        indeterminate
        :background-color="backgroundLoadingColor"
        :color="loadingColor"
        height="10"
        v-if="downloading"
      ></v-progress-linear>
      <v-form @submit.prevent="reset" @keydown="form.onKeydown($event)" ref="form" lazy-validation>
        <v-container grid-list-xl>
          <toolbar
            :title="title"
            :loading="form.busy"
            :buttons="buttons"
            @getReportPayrolls="getReportPayrolls"
          />
          <v-layout :id="ref" class="wrap justify-space-around form-body">
            <v-col lg="4" md="6" sm="6" cols="12">
              <v-select
                v-model="form.documentType"
                :items="documentTypes"
                label="Tipo de Documento"
                :rules="[rules.required]"
                required
              />
            </v-col>
            <v-col lg="4" md="6" sm="6" cols="12">
              <v-menu
                  v-model="form.dateMenu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="computedDateFormattedStart"
                      label="Fecha de Emisión Inicio"
                      :rules="[rules.required]"
                      required
                      readonly
                      hide-details
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-col cols="12" style="padding: 0 !important;">
                    <v-date-picker
                      :color="themeColor"
                      :max="form.dateMax"
                      v-model="form.dateStart"
                      @input="form.dateMenu1 = false"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" style="padding: 0 !important;">
                    <v-btn
                      block
                      :color="themeColor"
                      dark
                      @click="today('one')"
                    >
                      HOY
                    </v-btn>
                  </v-col>
                </v-menu>
            </v-col>
            <v-col lg="4" md="6" sm="6" cols="12">
              <v-menu
                  v-model="form.dateMenu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="computedDateFormattedEnd"
                      label="Fecha de Emisión Fin"
                      :rules="[rules.required]"
                      required
                      readonly
                      hide-details
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-col cols="12" style="padding: 0 !important;">
                    <v-date-picker
                      :color="themeColor"
                      v-model="form.dateEnd"
                      :max="form.dateMax"
                      @input="form.dateMenu2 = false"
                    />
                  </v-col>
                  <v-col cols="12" style="padding: 0 !important;">
                    <v-btn
                      block
                      :color="themeColor"
                      dark
                      @click="today('two')"
                    >
                      HOY
                    </v-btn>
                  </v-col>
                </v-menu>
            </v-col>
            <v-col lg="6" md="6" sm="12" cols="12">
              <v-select
                v-model="cat_province_id"
                :items="itemsProvince"
                item-value="code"
                item-text="name"
                label="Estado"
                @onchage="getProvincia()"
              />
            </v-col>
            <v-col lg="6" md="6" sm="12" cols="12">
              <vuetify-select :states="cat_province_id" :payroll="payroll" />
            </v-col>
            <v-col lg="12" md="12" sm="12" cols="12">
              <vuetify-select-api-code
                ref="refEmpleados"
                :api="empleado.apiEmpleados"
                :multiple="empleado.multiple"
                :placeholder="empleado.placeholder"
                @eventupdate="updateEmpleados"
                :selected="empleado.selectedEmpleados"
                :enterprise_id="form.enterprise_id"
                :showCode="true"
              />
            </v-col>
          </v-layout>
        </v-container>
      </v-form>
    </div>
    <v-row>
      <v-col class="col-12">
        <strong>Total de Registros Encontrados: {{ this.totalDocument }}</strong>
        <br/><br/>
        <strong>Total de Archivos a Descargar: {{ this.laps }}</strong>
        <br/><br/>
        <v-progress-linear
          v-model="progress"
          height="25"
          :background-color="backgroundLoadingColor"
          :color="loadingColor"
          dark
          v-if="downloading"
        >
          <strong>{{ Math.ceil(progress) }}%</strong>
        </v-progress-linear>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Form from 'vform';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { format, parseISO } from 'date-fns';
import { mask } from 'vue-the-mask';
import Toolbar from '~/components/Toolbar';
import VuetifySelect from '~/components/VuetifySelect';
import VuetifySelectApiCode from '~/components/VuetifySelectApiCode';
import 'vuetify/src/styles/main.sass';

Form.axios = window.axios;
export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('reportRevenuePayroll') };
  },
  components: {
    Toolbar,
    VuetifySelect,
    VuetifySelectApiCode,
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      loadingColor: 'theme/loadingColor',
      backgroundLoadingColor: 'theme/backgroundLoadingColor',
      themeColor: 'theme/themeColor',
    }),
    ref() {
      return this.form.id;
    },
    computedDateFormattedStart() {
        return this.form.dateStart ? moment(this.form.dateStart).format('DD-MM-YYYY') : '';
    },
    computedDateFormattedEnd() {
        return this.form.dateEnd ? format(parseISO(this.form.dateEnd), 'dd-MM-yyyy') : '';
    },
  },
  watch: {
    '$store.state.taxpayer.id': {
      handler() {
        this.form.empleados = [];
        this.$refs.refEmpleados.clean();
      },
      deep: true,
    },
  },
  async mounted() {
    await this.getProvincia().then((response) => {
      this.itemsProvince = response.data;
      this.cat_province_id = this.itemsProvince[0].code;
    });
    this.form.decimalPoint = 0.1.toLocaleString().replace(/\d/g, '');
  },
  directives: {
      mask,
    },
  data: () => ({
    title: 'Reporte Devengado',
    form: new Form({
      enterprise_id: 0,
      documentType: '01',
      status: '0',
      busy: false,
      dateStart: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      dateEnd: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      dateMax: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      dateMenu1: false,
      dateMenu2: false,
      typePortal: 'A',
      offset: 0,
      limit: 200000,
      tipo: 0,
      ext: 0,
      tiposDocumento: [],
      end: false,
      decimalPoint: null,
      rucSupplier: '',
      empleados: [],
    }),
    empleado: {
      selectedEmpleados: null,
      apiEmpleados: '/api/payroll/employees/getempleados',
      multiple: true,
      placeholder: 'Empleados',
    },
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
      numeric: (v) => /^([0-9])*$/.test(v) || 'El campo solo permite caracteres numericos.',
      format: (v) => /^(?=.*[0-9])/.test(v) || 'El campo solo permite caracteres numericos.',
      rifLength: (v) => (!v || v.length <= 12) || 'El campo debe tener máximo 12 caracteres.',
      rifFormat: (v) => (!v || /^[V,J,E,P,G]{1}[-][0-9]{1,9}[-][0-9]{1} || [V,J,E,P,G]{1}[-][0-9]{1,9}$/.test(v)) || 'Formato inválido.',
    },
    allHeaders: [{
      text: 'Nº Identificación Emisor',
      value: 'emisor_number_id',
      align: 'left',
      sortable: true,
    }, {
      text: 'Nº Identificación Adquiriente',
      value: 'receiver_number_id',
      align: 'left',
      sortable: true,
    },
    {
    text: 'Nº Documento',
    value: 'document_number',
    align: 'left',
    sortable: true,
    },
    {
    text: 'Nº Control',
    value: 'control_number',
    align: 'left',
    sortable: true,
    }, {
      text: 'Fecha Emisión',
      value: 'issue_date',
      align: 'left',
      sortable: true,
    }, {
      text: 'Fecha Recepción',
      value: 'reception_date',
      align: 'left',
      sortable: true,
    }, {
      text: 'Estado',
      value: 'status',
      align: 'left',
      sortable: true,
      }, {
      text: 'Observaciones',
      value: 'comments',
      align: 'left',
      sortable: true,
    }],
    documents: 0,
    dowloading: false,
    show: false,
    buttons: [
    {
          id: 'generate',
          icon: 'mdi-download',
          name: 'Descargar Reporte',
          event: 'getReportPayrolls',
          color: 'success',
        },
      /* {
        id: 'cancel',
        icon: 'mdi-download',
        name: 'Descargar Excel',
        event: 'downloadExcel',
        color: 'green',
      }, */
    ],
    showFilters: false,
    tiposDocumento: {
      selectedTiposDocumento: null,
      collection: [
        { code: 'V', name: 'VENEZOLANO' },
        { code: 'E', name: 'EXTRANJERO' },
        { code: 'J', name: 'JURÍDICO' },
        { code: 'P', name: 'PASAPORTE' },
        { code: 'G', name: 'GUBERNAMENTAL' },
        { code: 'C', name: 'COMUNAL' },
      ],
      multiple: true,
      placeholder: 'Tipos de Documento',
    },
    itemsProvince: [],
    cat_province_id: '',
    documentTypes: [
      { value: '01', text: 'Nómina' },
    ],
    invoiceStatus: [
      { value: '0', text: 'Todas' },
      { value: '1', text: 'Enviada' },
      { value: '2', text: ' Anulada' },
    ],
    downloading: false,
    progress: 0,
    totalDocument: 0,
    laps: 0,
    payroll: true,
  }),
  methods: {
    async getReportPayrolls() {
      const dateRange = moment(this.form.dateEnd).diff(this.form.dateStart, 'month', true);
      if (dateRange > 1) {
        this.$store.dispatch('notifications/show', {
              message: 'El rango de consulta no debe ser mayor a un mes',
              type: 'error',
        });
      } else if (this.$store.state.taxpayer.rif === null && this.form.empleados.length === 0) {
            this.$store.dispatch('notifications/show', {
                  message: 'Seleccione el Nº Indentificación del Emisor o Razón Social ó uno o más empleados',
                  type: 'error',
              });
      } else if (this.form.dateEnd < this.form.dateStart) {
          this.$store.dispatch('notifications/show', {
            message: 'La fecha fin no debe ser menor a la fecha inicio',
            type: 'error',
          });
      } else {
        this.validate();
        if (this.$refs.form.validate()) {
          this.downloading = true;
          this.form.enterprise_id = this.$store.state.taxpayer.id;
          this.form.rucSupplier = this.$store.state.taxpayer.rif;
          this.dowloading = true;
          this.form.busy = true;
          this.form.offset = 0;
          this.form.employees = this.empleados;

          const countDocument = await window.axios({
            method: 'post',
            url: '/api/payroll/reports/revenue/count',
            data: this.form,
          });

          this.totalDocument = countDocument.data.total;
          this.laps = 0;
          const laps = this.totalDocument % this.form.limit > 0
                      ? parseInt(this.totalDocument / this.form.limit, 10) + 1
                      : this.totalDocument / this.form.limit;
          for (let i = 0; i < laps; i++) {
            this.laps = laps;
            this.form.end = (this.laps === i + 1);
            // eslint-disable-next-line
            const data = await this.getReport();

            if (data.data.type !== undefined && data.data.type === 'error') {
              this.downloading = false;
              this.form.busy = false;
            } else {
              this.form.offset = (i + 1) * this.form.limit;
              this.downloadFile(data, `Reporte Devengados ${i + 1} de ${laps} Fecha ${format(parseISO(new Date().toISOString()), 'dd-MM-yyyy')}`);
              const value = (this.totalDocument / laps) * (i + 1);
              this.progress = (value / this.totalDocument) * 100;
            }
          }

          setTimeout(() => {
            this.downloading = false;
            this.form.busy = false;
            this.progress = 0;
          }, 1000);
      }
    }
    },
    getReport() {
      const url = '/api/payroll/reports/revenue';
      return window.axios({
        method: 'post',
        url,
        data: this.form,
      }).catch(() => {
        this.downloading = false;
        this.form.busy = false;
      });
    },
    downloadFile(response, filename) {
      const newBlob = new Blob([atob(response.data.file)], { type: 'csv' });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      const data = window.URL.createObjectURL(newBlob);
      const link = document.createElement('a');
      link.href = data;
      link.download = `${filename}.csv`;
      link.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    validateContribuyente() {
      if (this.$store.state.taxpayer.rif === null) {
          return this.$store.dispatch('notifications/show', {
            message: 'Seleccione el Nº Indentificación del Emisor o Razón Social',
            type: 'error',
          });
      }
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.form.busy = true;
        this.valid = true;
      }
    },
    getColor(status) {
        if (status.indexOf('1') !== -1) return 'green';
        return 'red';
    },
    updateTiposDocumento(tiposDocumento) {
      this.form.tiposDocumento = [];
      tiposDocumento.forEach((item) => {
        this.form.tiposDocumento.push(item);
      });
    },
    today(menu) {
      if (menu === 'one') {
        this.form.dateStart = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
        this.form.dateMenu1 = false;
      } else {
        this.form.dateEnd = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
        this.form.dateMenu2 = false;
      }
    },
    getProvincia() {
        const state = this.user.state != null ? this.user.state : 'Todos';
        const url = `/api/provinces/${state}`;
        return window.axios.get(url);
    },
    updateEmpleados(empleados) {
      this.form.empleados = [];
      empleados.forEach((item) => {
        this.form.empleados.push(item);
      });
    },
  },
};
</script>
<style scoped>
.flip-card {
  font-size: 2rem !important;
}
.flip-clock__slot {
  font-size: 1rem !important;
}
.flip-card__top,
.flip-card__bottom,
.flip-card__back-bottom,
.flip-card__back::before,
.flip-card__back::after {
  color: #ffffff !important;
  background: rgba(35, 127, 233, 0.932) !important;
}
</style>
